import React from 'react';

import colours from '~/utils/colours';
import SnapButton, {
  snapButtonStyles,
} from '~/App/Components/Buttons/SnapButton';

const buttonStyles = {
  container: (options) => {
    const baseStyles = snapButtonStyles.container(options);

    return {
      ...baseStyles,

      margin: 0,
    };
  },

  afterIconContainer: ({ base }) => ({
    ...base,
    fontSize: '1.1em',
    margin: '0 0 0 3px',
  }),
};

const filterTheme = {
  default: {
    fg: colours.greyDark,
    bg: 'white',
    highlight: colours.blue,
  },

  active: {
    fg: colours.blue,
    bg: 'white',
    highlight: colours.blue,
  },
};

const filterStyles = {
  ...buttonStyles,

  container: (options) => {
    const baseStyles = buttonStyles.container(options);
    const { state } = options;

    return {
      ...baseStyles,

      borderColor: state.active ? colours.blue : 'rgba(0, 0, 0, 0)',
      boxShadow: state.active ? baseStyles.boxShadow : 'none',

      '&:hover': {
        ...baseStyles['&:hover'],
        boxShadow: baseStyles.boxShadow,
      },
    };
  },
};

function HeaderButton(props) {
  return <SnapButton styles={buttonStyles} {...props} />;
}

export function HeaderFilter(props) {
  return <SnapButton theme={filterTheme} styles={filterStyles} {...props} />;
}

export const styles = buttonStyles;

export default HeaderButton;
